module.exports = __webpack_public_path__ + "img/email-ico.651c73b6.svg";